import { onRedirectToAllowedActivation } from "app/pages/activation/routing/redirectHooks/onRedirectToAllowedActivation";
import { DigitalSuiteHomePageContainer } from "app/pages/digital-suite/home-page/DigitalSuiteHomePageContainer";
import { MarketResearchRoot } from "app/pages/market-research/MarketResearchRoot";
import { MarketResearchWrapper } from "app/pages/market-research/MarketResearchWrapper";
import { redirectPipe } from "app/routes/handlers/redirectFunctions/redirectPipe";
import { getHasAvailableAllocations } from "app/services/AvailableAllocationsService";
import { resolvers } from "single-spa/react-app/config/resolvers/resolvers";
import { marketResearchConfig } from "single-spa/react-app/config/solutions25/marketResearchConfig";
import type { RouterStateConfig } from "single-spa/react-app/router/IRouterState";

import { industryResearchConfig } from "./industryResearchConfig";

export const digitalSuiteMarketResearchConfig: RouterStateConfig = {
    digitalsuite_marketresearch: {
        parent: "sw",
        abstract: true,
        packageName: "digitalsuite",
        url: "/digitalsuite",
        resolve: [resolvers.customCategories],
        component: MarketResearchWrapper,
        configId: "WebMarketAnalysisOverviewHomepage",
        secondaryBarType: "DigitalSuiteMarketResearch",
        navBarContainerClassName: "accordion-side-bar",
    },
    digitalsuite_marketresearch_root: {
        abstract: true,
        parent: "digitalsuite_marketresearch",
        component: MarketResearchRoot,
    },
    "digitalsuite-home": {
        parent: "digitalsuite_marketresearch",
        url: "/home",
        component: DigitalSuiteHomePageContainer,
        configId: "WebAnalysis",
        configIdDeps: [
            "WorldwideOverviewPage",
            "KeywordAnalysis",
            "AppAnalysis",
            "AppRetentionFront",
            "AppAudienceInterests",
            "AppPerformanceReport",
        ],
        packageName: "digitalsuite",
        isSecondaryBarOpen: false,
        secondaryBarType: "None",
        isPrimarySidebarAlwaysOpen: true,
        pageId: {
            section: "digitalsuite",
            subSection: "homepage",
        },
        trackingId: {
            section: "digitalsuite",
            subSection: "homepage",
            subSubSection: "",
        },
        pageTitle: "digitalsuite.homepage.title",
        redirectTo: redirectPipe(onRedirectToAllowedActivation() as any),
        resolve: [
            {
                token: "hasAvailableAllocations",
                deps: ["$transition$"],
                resolveFn: getHasAvailableAllocations,
            },
        ],
    },
    ...industryResearchConfig,
    ...marketResearchConfig,
};
